// @flow
import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import FloatingBottom from '../../../../../../elements/FloatingBottom/FloatingBottom';
import {CommaFormat} from '../../../../../../elements/Price/Price';

import bbva from '../../../../../../assets/img/home/features/bbva.png';
import diners from '../../../../../../assets/img/home/features/diners.png';
import bcp from '../../../../../../assets/img/home/features/bcp.png';
import warranty from '../../../../../../assets/img/home/features/warranty.png';
import star from '../../../../../../assets/img/home/features/blue-star.png';
import asesorias from '../../../../../../assets/img/home/features/asesorias.png';

import style from './TotalPrice.scss';
import buttonStyle from '../../../../../../assets/styles/button.scss';

import type {ForecastCourier, ForecastPricesApiReq, ForecastTier} from '../../../../QuoteStep/api';
import {ForecastItem} from "../../../../QuoteStep/api";


type Props = {
  forecastClassic?: ForecastTier;
  forecastCourier?: ForecastCourier;
  handleClickBuyNow: () => void;
  handleClickAddCart: () => void;
  forecastRequest?: ForecastPricesApiReq;
};

export default function TotalPrice(props: Props) {
  const {
    forecastClassic,
    forecastCourier,
    handleClickBuyNow,
    handleClickAddCart,
    forecastRequest,
  } = props;

  const title = forecastCourier ? 'Precio de envío' : 'Precio Total';

  let price;

  if (forecastCourier) price = forecastCourier.total;
  if (forecastClassic) price = forecastClassic.total;

  const total = price ? (
    <Fragment>
      $ <CommaFormat price={price || ''}/>
    </Fragment>
  ) : '??.??';

  const priceContent = (
    <Fragment>
      <div className={style.priceWrap}>
        <div className={style.textWrap}>
          <p>{title}</p>
          <span>Incluye todos los gastos</span>
        </div>
        <p className={style.price}>{total}</p>
      </div>
      <button className={classNames(buttonStyle.btn, buttonStyle.lightBlue, style.pay)}
              onClick={() => handleClickBuyNow()}>
        Ir a pagar
      </button>
      <button className={style.addCart}
              onClick={() => handleClickAddCart()}>
        Agregar al carrito
      </button>
    </Fragment>
  );

  const showCallHelp = (): boolean => {
    return false;
    /*if (!forecastRequest) return false;

    return forecastRequest.items
      .some((i: ForecastItem) => [1, 3, 4, 11].includes(i.categoryId))*/
  };

  return (
    <Fragment>
      <div className={classNames(style.totalPriceWrap, style.desktop)}>
        {priceContent}
      </div>
      <br/>
      <div>
        {showCallHelp() && (
            <div className={style.helpWrap}>
              <img src={asesorias}/>
              <p>
                Programa una videollamada GRATIS con nuestros expertos
              </p>
              <a className={classNames(buttonStyle.btn, buttonStyle.darkGrey,
                  style.callBtn)}
                 href="https://calendly.com/qempomeet/15min"
                 target="_blank">Programar llamada</a>
            </div>
        )}
        <div>
          <div className={classNames(style.featureWrap)}>
            <img src={warranty} alt="warranty"/>
            <span className={style.bold}>Garantía gratis de 90 días</span>
          </div>
          {/*<div className={style.featureWrap}>
            <img src={bcp} alt="bcp"/>
            <span>3 cuotas sin intereses con VISA BCP</span>
          </div>*/}
          <div className={style.featureWrap}>
            <img src={diners} alt="diners"/>
            <span>3 cuotas sin intereses con Diners</span>
          </div>
          <div className={style.featureWrap}>
            <img src={bbva} alt="bbva"/>
            <span>3 cuotas sin intereses VISA BBVA</span>
          </div>
          <div className={style.featureWrap}>
            <img className={style.star} src={star} alt="star"/>
            <span>Si es tu primera vez:
            <a
                target="_blank"
                href="https://help.qempo.com/article/bqrn8u8a1z-c-mo-crear-un-pedido-de-manera-correcta"
                className={style.link}
            >
              Revisa esta info.
            </a>
          </span>
          </div>
        </div>
      </div>
      {forecastRequest && (
        <FloatingBottom offSetY={196} untilTablet>
          <div className={classNames(style.totalPriceWrap, style.mobile)}>
            {priceContent}
          </div>
        </FloatingBottom>
      )}
    </Fragment>
  );
}

TotalPrice.propTypes = {
  forecastClassic: PropTypes.object,
  forecastCouriers: PropTypes.object,
  handleClickBuyNow: PropTypes.func.isRequired,
  handleClickAddCart: PropTypes.func.isRequired,
  forecastRequest: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/TotalPrice/TotalPrice.jsx